import styled from 'styled-components';
import { BoxSingleCard, MainListContainer, SpaceSingleCard } from './GenericCssComponent';
import { useNavigate } from 'react-router-dom';

function RenderAllListPpvDescription({listPpv}) {
    const navigate = useNavigate();

    // Funzione per navigare alla pagina specifica del ppv
    const navigateToPpv = (ppv) => {
        const ppvId = ppv.id;
        const ppvName = ppv.name;
        let url = '/ppv/i_' + ppvId + '_d_' + ppvName;
        navigate(url);
    }

    // Render spazio sinistro
    function renderSpaceSingleCardLeft(ppv, index) {
        return (
            <SpaceSingleCard key={ppv.id} className='space-single-card left' onClick={() => navigateToPpv(ppv)}>
                <BoxSingleCard className='box-single-card left'>
                    <div className='box-info-ppv left'>
                        {ppv.name}
                    </div>
                    <img src={process.env.REACT_APP_STORAGE_URL + ppv.img_path} alt={ppv.img_path + "_alt"} className='poster-ppv' />
                </BoxSingleCard>
            </SpaceSingleCard>
        )
    }

    // Render spazio destro
    function renderSpaceSingleCardRight(ppv, index) {
        return (
            <SpaceSingleCard key={ppv.id} className='space-single-card right' onClick={() => navigateToPpv(ppv)}>
                <BoxSingleCard className='box-single-card right'>
                    <img src={process.env.REACT_APP_STORAGE_URL + ppv.img_path} alt={ppv.img_path + "_alt"} className='poster-ppv' />
                    <div className='box-info-ppv right'>
                        {ppv.name}
                    </div>
                </BoxSingleCard>
            </SpaceSingleCard>
        )
    }

    // JSX
    return (
        <MainListContainer className='main-list-container'>
            {listPpv.map((ppv, index) => (
                // Se indice è pari, la box info è a sinistra, altrimenti a destra
                // index % 2 === 0 ? 
                    // renderSpaceSingleCardLeft(ppv, index) 
                //  : 
                    renderSpaceSingleCardRight(ppv, index)
                )
            )}
        </MainListContainer>
    )
}

export default RenderAllListPpvDescription;